import { Box, Typography } from '@mui/material';
import theme from 'src/style-system/theme';
import { useStyles } from './useStyles';

export const tabContent: { id: number; value: string; name: string }[] = [
  { id: 0, value: 'All', name: 'All' },
  { id: 1, value: 'Recipes', name: 'page' },
  { id: 2, value: 'Fusion Recipes', name: 'fusion_recipe' },
  { id: 3, value: 'Lifestyle', name: 'story' },
  { id: 4, value: 'Announcements', name: 'announcement' },
];

interface ITabSection {
  headerIndex: number;
  setHeaderIndex: (value: number) => void;
}

const TabSection = ({ headerIndex, setHeaderIndex }: ITabSection) => {
  const classes = useStyles();

  const handleTabClick = (index: number) => {
    setHeaderIndex(index);
  };

  return (
    <Box className={classes.mainContainer}>
      {tabContent.map((item, index) => (
        <Box key={item.id}>
          <Typography
            variant="body1"
            align="center"
            color="garamMasala.main"
            className={classes.title}
            sx={{
              borderBottom:
                headerIndex === index
                  ? `10px solid ${theme.palette.turmeric.main}`
                  : '',
              paddingBottom: headerIndex === index ? '15px' : '25px',
            }}
            onClick={() => handleTabClick(index)}
          >
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TabSection;
